import React from "react";

export default function Navbar() {
  return (
    <nav
      className="navbar navbar-expand-lg py-0 bg-secondary text-uppercase fixed-top"
      id="mainNav"
    >
      <div className="container">
        <a className="navbar-brand" href="#page-top">
          Khoi-Portfolio
        </a>
        <button
          className="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold text-white"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Menu <i className="fas fa-bars"></i>
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-3 px-0 px-lg-3 js-scroll-trigger"
                href="#about"
              >
                About
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-3 px-0 px-lg-3 js-scroll-trigger"
                href="#portfolio"
              >
                Portfolio
              </a>
            </li>

            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-3 px-0 px-lg-3 js-scroll-trigger"
                href="#skills"
              >
                Skills
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-3 px-0 px-lg-3 js-scroll-trigger"
                href="#experience"
              >
                Experience
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
